import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderConfigService, LanguageService } from '@os-components';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { SearchCriteria, SearchCriteriaResponse } from './search-criteria';

@Injectable({
    providedIn: 'root',
})
export class SearchCriteriaExplanationService {
    private allSearchCritariaObs: Observable<SearchCriteria[]>;
    private serialNumberSearchCritariaObs: Observable<SearchCriteria>;

    private project: Observable<string>;

    public constructor(
        private http: HttpClient,
        private configService: HeaderConfigService,
        private languageService: LanguageService
    ) {
        this.project = this.configService.cmsProject;
        this.allSearchCritariaObs = combineLatest([this.project, this.languageService.onLanguageChange]).pipe(
            switchMap(([project, language]) =>
                this.fetchAllSearchCriteriaExplanation(project, language.toUpperCase())
            ),
            shareReplay(1)
        );
        this.serialNumberSearchCritariaObs = combineLatest([
            this.project,
            this.languageService.onLanguageChange,
        ]).pipe(
            switchMap(([project, language]) =>
                this.fetchSearchCriteriaExplanation(project, 'serial_number', language.toLowerCase())
            ),
            shareReplay(1)
        );
    }

    public get allSearchCriteria() {
        return this.allSearchCritariaObs;
    }

    public get serialNumberSearchCriteria() {
        return this.serialNumberSearchCritariaObs;
    }

    public fetchSearchCriteriaExplanation(
        project: string,
        id: string,
        language: string
    ): Observable<SearchCriteria> {
        return this.http
            .get<SearchCriteria>(`/caas/direct/${project}/search-criteria/${id}_${language}`)
            .pipe(map((response) => ({ headline: response.headline, content: response.content })));
    }

    private fetchAllSearchCriteriaExplanation(
        project: string,
        language: string
    ): Observable<SearchCriteria[]> {
        return this.http
            .get<SearchCriteriaResponse>(
                `/caas/direct/${project}/search-criteria?filter={'fs_language':'${language}'}'}`
            )
            .pipe(
                map((response) =>
                    //TODO: handle if no response is available
                    response._embedded['rh:doc'].reduce(
                        (prev, curr) => [
                            ...prev,
                            { headline: curr.headline, content: curr.content } as SearchCriteria,
                        ],
                        [] as SearchCriteria[]
                    )
                )
            );
    }
}
